import React, { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

type Theme = "briter" | "catalyst" | "giz";

type AppContextType = {
  sidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  setSidebarOpen: (sidebarOpen: boolean) => void;
  setSidebarCollapsed: (isSidebarCollapsed: boolean) => void;
  selectedLink: string;
  setSelectedLink: (selectedLink: string) => void;
  showMenu: boolean;
  setShowMenu: (showMenu: boolean) => void;
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const AppContext = React.createContext<AppContextType>({
  sidebarOpen: false,
  isSidebarCollapsed: false,
  setSidebarOpen: () => null,
  setSidebarCollapsed: () => null,
  selectedLink: "",
  setSelectedLink: () => null,
  showMenu: false,
  setShowMenu: () => null,
  theme: "briter",
  setTheme: (theme: Theme) => null,
});

export const useAppContext = () => React.useContext(AppContext);

const AppProvider: React.FC<any> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>("briter");
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [isSidebarCollapsed, setSidebarCollapsed] = useLocalStorage(
    "sidebarWidthExpanded",
    false
  );
  const [selectedLink, setSelectedLink] = React.useState<string>("");
  const [showMenu, setShowMenu] = React.useState(true);

  return (
    <AppContext.Provider
      value={{
        sidebarOpen,
        setSidebarOpen,
        isSidebarCollapsed,
        setSidebarCollapsed,
        selectedLink,
        setSelectedLink,
        showMenu,
        setShowMenu,
        theme,
        setTheme,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
